import PropTypes from 'prop-types';

export const previewContentPropTypes = {
  alignment: PropTypes.string,
  children: PropTypes.node.isRequired,
  trigger: PropTypes.shape({}),
  className: PropTypes.string,
};

export const contentPropTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

export const actionsPropTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      icon: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  className: PropTypes.string,
};

export const statusPropTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  text: PropTypes.string,
  className: PropTypes.string,
};

export const coverPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export const contentContainerPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export const contentTopContainerPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
